import script from "./EditLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditLink.vue?vue&type=script&setup=true&lang=ts"

import "./EditLink.vue?vue&type=style&index=0&id=00d8db6a&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00d8db6a"]])

export default __exports__